import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-svgfechasalida',
  templateUrl: './svgfechasalida.component.html',
  styleUrls: ['./svgfechasalida.component.css']
})
export class SvgfechasalidaComponent implements OnInit {
  @Input() color: string;
  constructor() { }

  ngOnInit() {
  }

}
